"use strict";
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        ui.KeyCodesText = {
            8: "Backspace",
            9: "Tab",
            13: "Enter",
            16: "Shift",
            17: "Ctrl",
            18: "Alt",
            27: "Esc",
            32: "Space",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: String.fromCharCode(8592),
            38: String.fromCharCode(8593),
            39: String.fromCharCode(8594),
            40: String.fromCharCode(8595),
            46: "Delete",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            110: ".",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            186: ";",
            188: ",",
            190: ".",
            191: "/",
            222: "'",
            numbers: "[1..9]",
        };
        // tslint:disable:object-literal-sort-keys
        var KeyCodes;
        (function (KeyCodes) {
            KeyCodes[KeyCodes["backSpace"] = 8] = "backSpace";
            KeyCodes[KeyCodes["tab"] = 9] = "tab";
            KeyCodes[KeyCodes["enter"] = 13] = "enter";
            KeyCodes[KeyCodes["shift"] = 16] = "shift";
            KeyCodes[KeyCodes["ctrl"] = 17] = "ctrl";
            KeyCodes[KeyCodes["alt"] = 18] = "alt";
            KeyCodes[KeyCodes["esc"] = 27] = "esc";
            KeyCodes[KeyCodes["spacebar"] = 32] = "spacebar";
            KeyCodes[KeyCodes["pageUp"] = 33] = "pageUp";
            KeyCodes[KeyCodes["pageDown"] = 34] = "pageDown";
            KeyCodes[KeyCodes["end"] = 35] = "end";
            KeyCodes[KeyCodes["home"] = 36] = "home";
            KeyCodes[KeyCodes["leftArrow"] = 37] = "leftArrow";
            KeyCodes[KeyCodes["upArrow"] = 38] = "upArrow";
            KeyCodes[KeyCodes["rightArrow"] = 39] = "rightArrow";
            KeyCodes[KeyCodes["downArrow"] = 40] = "downArrow";
            KeyCodes[KeyCodes["deleteKey"] = 46] = "deleteKey";
            KeyCodes[KeyCodes["Number0"] = 48] = "Number0";
            KeyCodes[KeyCodes["Number1"] = 49] = "Number1";
            KeyCodes[KeyCodes["Number2"] = 50] = "Number2";
            KeyCodes[KeyCodes["Number3"] = 51] = "Number3";
            KeyCodes[KeyCodes["Number4"] = 52] = "Number4";
            KeyCodes[KeyCodes["Number5"] = 53] = "Number5";
            KeyCodes[KeyCodes["Number6"] = 54] = "Number6";
            KeyCodes[KeyCodes["Number7"] = 55] = "Number7";
            KeyCodes[KeyCodes["Number8"] = 56] = "Number8";
            KeyCodes[KeyCodes["Number9"] = 57] = "Number9";
            KeyCodes[KeyCodes["semicolon_ff"] = 59] = "semicolon_ff";
            KeyCodes[KeyCodes["letterA"] = 65] = "letterA";
            KeyCodes[KeyCodes["letterB"] = 66] = "letterB";
            KeyCodes[KeyCodes["letterC"] = 67] = "letterC";
            KeyCodes[KeyCodes["letterD"] = 68] = "letterD";
            KeyCodes[KeyCodes["letterE"] = 69] = "letterE";
            KeyCodes[KeyCodes["letterF"] = 70] = "letterF";
            KeyCodes[KeyCodes["letterG"] = 71] = "letterG";
            KeyCodes[KeyCodes["letterH"] = 72] = "letterH";
            KeyCodes[KeyCodes["letterI"] = 73] = "letterI";
            KeyCodes[KeyCodes["letterJ"] = 74] = "letterJ";
            KeyCodes[KeyCodes["letterK"] = 75] = "letterK";
            KeyCodes[KeyCodes["letterL"] = 76] = "letterL";
            KeyCodes[KeyCodes["letterM"] = 77] = "letterM";
            KeyCodes[KeyCodes["letterN"] = 78] = "letterN";
            KeyCodes[KeyCodes["letterO"] = 79] = "letterO";
            KeyCodes[KeyCodes["letterP"] = 80] = "letterP";
            KeyCodes[KeyCodes["letterQ"] = 81] = "letterQ";
            KeyCodes[KeyCodes["letterR"] = 82] = "letterR";
            KeyCodes[KeyCodes["letterS"] = 83] = "letterS";
            KeyCodes[KeyCodes["letterT"] = 84] = "letterT";
            KeyCodes[KeyCodes["letterU"] = 85] = "letterU";
            KeyCodes[KeyCodes["letterV"] = 86] = "letterV";
            KeyCodes[KeyCodes["letterW"] = 87] = "letterW";
            KeyCodes[KeyCodes["letterX"] = 88] = "letterX";
            KeyCodes[KeyCodes["letterY"] = 89] = "letterY";
            KeyCodes[KeyCodes["letterZ"] = 90] = "letterZ";
            KeyCodes[KeyCodes["decimal"] = 110] = "decimal";
            KeyCodes[KeyCodes["f1"] = 112] = "f1";
            KeyCodes[KeyCodes["f2"] = 113] = "f2";
            KeyCodes[KeyCodes["f3"] = 114] = "f3";
            KeyCodes[KeyCodes["f4"] = 115] = "f4";
            KeyCodes[KeyCodes["f5"] = 116] = "f5";
            KeyCodes[KeyCodes["f6"] = 117] = "f6";
            KeyCodes[KeyCodes["f7"] = 118] = "f7";
            KeyCodes[KeyCodes["f8"] = 119] = "f8";
            KeyCodes[KeyCodes["f9"] = 120] = "f9";
            KeyCodes[KeyCodes["f10"] = 121] = "f10";
            KeyCodes[KeyCodes["f11"] = 122] = "f11";
            KeyCodes[KeyCodes["f12"] = 123] = "f12";
            KeyCodes[KeyCodes["semicolon"] = 186] = "semicolon";
            KeyCodes[KeyCodes["comma"] = 188] = "comma";
            KeyCodes[KeyCodes["period"] = 190] = "period";
            KeyCodes[KeyCodes["forwardslash"] = 191] = "forwardslash";
            KeyCodes[KeyCodes["apostrophe"] = 222] = "apostrophe";
            /**
             * An array containing the key codes for the number row, 1-9.
             */
            KeyCodes[KeyCodes["numbers"] = [49, 50, 51, 52, 53, 54, 55, 56, 57]] = "numbers";
        })(KeyCodes = ui.KeyCodes || (ui.KeyCodes = {}));
        // tslint:enable:object-literal-sort-keys
        var ShortcutCategory;
        (function (ShortcutCategory) {
            /** Shortcuts on the focused control */
            ShortcutCategory["ElementAction"] = "ElementAction";
            /** Navigate to a region inside the form or go to a different form/dialog */
            ShortcutCategory["Navigate"] = "Navigate";
            /** Shortcuts dealing with the current data record or data */
            ShortcutCategory["ActOnData"] = "ActOnData";
            /** Shortcuts specific to closing the form or a region */
            ShortcutCategory["Close"] = "Close";
            /** Any shortcuts that aren't tagged otherwise. */
            ShortcutCategory["Other"] = "Other";
        })(ShortcutCategory = ui.ShortcutCategory || (ui.ShortcutCategory = {}));
        ui.isInChordMode = false;
        ui.chordKeysPressed = null;
        /**
         * Checks if the key combination could modify the value of an input.
         */
        function isChangeableKeyCombo(event) {
            var retVal = false;
            var modifier = event.ctrlKey || event.metaKey;
            if (modifier) {
                switch (event.which) {
                    case $dyn.ui.KeyCodes.letterV:
                    case $dyn.ui.KeyCodes.letterX:
                    case $dyn.ui.KeyCodes.letterY:
                    case $dyn.ui.KeyCodes.letterZ:
                        retVal = true;
                }
            }
            return retVal;
        }
        ui.isChangeableKeyCombo = isChangeableKeyCombo;
        /**
         * Checks if the key combination can be printed.
         * @description Does not check the modifier keys. This is by design so that ctrl+v or alt+130 return as true, but
         *              this will allow something like ctrl+spacebar to return true even if it does nothing.
         */
        function isPrintableKeyCode(keycode) {
            var valid = (keycode > 45 && keycode < 58) || // number keys
                (keycode === $dyn.ui.KeyCodes.spacebar) ||
                (keycode === $dyn.ui.KeyCodes.backSpace) ||
                (keycode === $dyn.ui.KeyCodes.enter) ||
                (keycode > 64 && keycode < 91) || // letter keys
                (keycode > 95 && keycode < 112) || // numpad keys
                (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
                (keycode > 218 && keycode < 223) || // [\]' (in order)
                (keycode > 255); // unicode characters
            return valid;
        }
        ui.isPrintableKeyCode = isPrintableKeyCode;
        /**
         * Determines if the keyboard event would change the display value of an input element
         * @returns True if the event would change the display value of an input element, otherwise false
         */
        function isTextualKeyEvent(event) {
            return $dyn.ui.isPrintableKeyCode(event.which) && event.which !== $dyn.ui.KeyCodes.enter &&
                // CTRL + Backspace clears all text, CTRL + Delete clears all text in front of the cursor. Consider both a textual keypress.
                (!event.ctrlKey || event.which === $dyn.ui.KeyCodes.backSpace || event.which === $dyn.ui.KeyCodes.deleteKey) &&
                // <Meta Key> + Backspace clears all text, <Meta Key> + Delete clears all text in front of the cursor. Consider both a textual keypress.
                (!event.metaKey || event.which === $dyn.ui.KeyCodes.backSpace || event.which === $dyn.ui.KeyCodes.deleteKey) &&
                !event.altKey;
        }
        ui.isTextualKeyEvent = isTextualKeyEvent;
    })(ui = $dyn.ui || ($dyn.ui = {}));
    var util;
    (function (util) {
        var Lookup;
        (function (Lookup) {
            /**
             * The array of keycodes that we forward to the lookup from the control
             */
            Lookup.KeysToSendToLookup = [
                $dyn.ui.KeyCodes.downArrow,
                $dyn.ui.KeyCodes.upArrow,
                $dyn.ui.KeyCodes.enter,
                $dyn.ui.KeyCodes.pageUp,
                $dyn.ui.KeyCodes.pageDown,
            ];
        })(Lookup = util.Lookup || (util.Lookup = {}));
        function CompareShortcuts(a, b) {
            return a.descriptionText.localeCompare(b.descriptionText, $dyn.peek($dyn.user) && $dyn.peek($dyn.peek($dyn.user).Locale) ? $dyn.peek($dyn.peek($dyn.user).Locale) : undefined);
        }
        /**
         * Gets a string describing the keydown event
         */
        function getTextFromKeydownEvent(event) {
            var keysText = "";
            if (event.which !== $dyn.ui.KeyCodes.shift &&
                event.which !== $dyn.ui.KeyCodes.ctrl &&
                event.which !== $dyn.ui.KeyCodes.alt) {
                if (event.altKey) {
                    keysText += "Alt+";
                }
                if (event.ctrlKey) {
                    keysText += "Ctrl+";
                }
                if (event.shiftKey) {
                    keysText += "Shift+";
                }
            }
            keysText += $dyn.ui.KeyCodesText[event.which];
            return keysText;
        }
        util.getTextFromKeydownEvent = getTextFromKeydownEvent;
        /**
         * Turns a keys object into text
         */
        function getTextFromKeysObject(keys) {
            var keysText = "";
            if (keys.alt) {
                keysText += "Alt+";
            }
            if (keys.ctrl) {
                keysText += "Ctrl+";
            }
            if (keys.shift) {
                keysText += "Shift+";
            }
            if (keys.keyCode) {
                if (keys.keyCode instanceof Array) {
                    if (keys.keyCode === $dyn.ui.KeyCodes.numbers) {
                        keysText += $dyn.ui.KeyCodesText.numbers;
                    }
                    else {
                        var lastIndex_1 = keys.keyCode.length - 1;
                        keys.keyCode.forEach(function (code, index) {
                            keysText += $dyn.ui.KeyCodesText[code];
                            if (index < lastIndex_1) {
                                keysText += " or ";
                            }
                        });
                    }
                }
                else {
                    keysText += $dyn.ui.KeyCodesText[keys.keyCode];
                }
            }
            return keysText;
        }
        util.getTextFromKeysObject = getTextFromKeysObject;
        /**
         * Gets the shortcut text for a control
         * @returns Map containing shortcuts for each ShortcutCategory
         */
        function getShortcutsTextForControl(control, activeElement, shortcutsTakenMap, categorize) {
            if (categorize === void 0) { categorize = false; }
            var categorizedShortcuts = {};
            if (!shortcutsTakenMap) {
                shortcutsTakenMap = {};
            }
            if (control && control.Shortcuts) {
                // tslint:disable-next-line:forin
                for (var shortcutName in control.Shortcuts) {
                    var shortcut = control.Shortcuts[shortcutName];
                    var showToUser = (shortcut.ShowToUser !== false);
                    if (showToUser && shortcut.ShowToUser instanceof Function) {
                        showToUser = $dyn.applyFunction(shortcut.ShowToUser, control, [activeElement]);
                    }
                    if (showToUser) {
                        var keyText = "";
                        var descriptionText = "";
                        var chordKeys = shortcut.ChordKeys;
                        if (chordKeys) {
                            keyText += $dyn.util.getTextFromKeysObject(chordKeys) + ",";
                        }
                        var keys = shortcut.Keys;
                        if (keys) {
                            keyText += $dyn.util.getTextFromKeysObject(keys);
                        }
                        if (!shortcutsTakenMap[keyText]) {
                            shortcutsTakenMap[keyText] = true;
                            if (shortcut.Description) {
                                if (shortcut.Description instanceof Function) {
                                    descriptionText = $dyn.applyFunction(shortcut.Description, control, [activeElement]);
                                }
                                else {
                                    descriptionText = shortcut.Description;
                                }
                            }
                            var category = void 0;
                            if (categorize) {
                                category = shortcut.Category ? shortcut.Category : $dyn.ui.ShortcutCategory.Other;
                            }
                            else {
                                category = $dyn.ui.ShortcutCategory.ElementAction;
                            }
                            if (!categorizedShortcuts[category]) {
                                categorizedShortcuts[category] = [];
                            }
                            categorizedShortcuts[category].push({ descriptionText: descriptionText, keyText: keyText });
                        }
                    }
                }
            }
            if (!categorize && categorizedShortcuts[$dyn.ui.ShortcutCategory.ElementAction]) {
                categorizedShortcuts[$dyn.ui.ShortcutCategory.ElementAction].sort(CompareShortcuts);
            }
            return categorizedShortcuts;
        }
        util.getShortcutsTextForControl = getShortcutsTextForControl;
        /**
         * Gets the available shortcut text for control and its' parents
         */
        function getAvailableShortcutsText(control, activeElement) {
            // TODO: add interface for return type
            var shortcuts = {};
            // tslint:disable-next-line:forin
            for (var shortcutCategory in $dyn.ui.ShortcutCategory) {
                shortcuts[shortcutCategory] = [];
            }
            var parent = control.element;
            var currentControl = control;
            var shortcutsTakenMap = {};
            var controlShortcuts = $dyn.util.getShortcutsTextForControl(control, activeElement, shortcutsTakenMap);
            shortcuts[$dyn.ui.ShortcutCategory.ElementAction] = controlShortcuts[$dyn.ui.ShortcutCategory.ElementAction];
            while (parent) {
                var currentContext = $dyn.context(parent);
                if (currentContext && currentControl !== currentContext) {
                    currentControl = currentContext;
                    controlShortcuts = $dyn.util.getShortcutsTextForControl(currentControl, activeElement, shortcutsTakenMap, true);
                    // tslint:disable-next-line:forin
                    for (var controlCategory in controlShortcuts) {
                        Array.prototype.push.apply(shortcuts[controlCategory], controlShortcuts[controlCategory]);
                    }
                }
                parent = parent.parentNode;
            }
            var shellShortcuts = $dyn.util.getShortcutsTextForControl($dyn.shell, activeElement, shortcutsTakenMap, true);
            // tslint:disable-next-line:forin
            for (var shellCategory in shellShortcuts) {
                Array.prototype.push.apply(shortcuts[shellCategory], shellShortcuts[shellCategory]);
            }
            for (var category in shortcuts) {
                if (category !== $dyn.ui.ShortcutCategory.ElementAction) {
                    shortcuts[category].sort(CompareShortcuts);
                }
            }
            return shortcuts;
        }
        util.getAvailableShortcutsText = getAvailableShortcutsText;
        /**
         * Handles the keydown event for a control's defined shortcuts
         */
        function handleShortcuts(control, event) {
            var ignoreShorcuts = event.originalEvent ? event.originalEvent.IgnoreShortcuts : false;
            $.each(control.Shortcuts, function (name, shortcut) {
                if (!ignoreShorcuts || shortcut.Force) {
                    var checkKeys = !$dyn.ui.isInChordMode;
                    if (shortcut.ChordKeys) {
                        if ($dyn.ui.chordKeysPressed) {
                            checkKeys = $dyn.util.isChordKeyPressed($dyn.ui.chordKeysPressed, shortcut.ChordKeys);
                        }
                        else if ($dyn.util.isShortcutKeyPressed(event, shortcut.ChordKeys)) {
                            $dyn.ui.chordKeysPressed = shortcut.ChordKeys;
                            $dyn.ui.isInChordMode = true;
                            var keyCombo = $dyn.util.getTextFromKeysObject(shortcut.ChordKeys);
                            // call show cord is not a valid command
                            $($dyn.shell.chordNotification).text($dyn.format($dyn.label("Framework_ChordStarted"), keyCombo)).show();
                            event.preventDefault();
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("ExecuteShortcuts: Matched chord");
                            event.stopPropagation();
                            return false; // break each loop
                        }
                        else {
                            checkKeys = false;
                        }
                    }
                    if (checkKeys && $dyn.util.isShortcutKeyPressed(event, shortcut.Keys)) {
                        var telemetry_1 = (shortcut.RecordTelemetry !== undefined) ? shortcut.RecordTelemetry : true;
                        if (telemetry_1) {
                            var eventOptions = { inputType: $dyn.telemetry.InputType.keyboard, extendedData: name + ": " + JSON.stringify(shortcut.Keys) };
                            if (shortcut.ChordKeys) {
                                eventOptions.extendedData += ", " + JSON.stringify(shortcut.ChordKeys);
                            }
                            if (shortcut.Keys.keyCode.length > 1) {
                                // Record which one of the possible keys was pressed
                                eventOptions.userDefined1 = event.which;
                            }
                            if (control.IsForm) {
                                $dyn.telemetry.addFormActionEvent(control, $dyn.telemetry.ActionEvents.hotKeyUsed, eventOptions);
                            }
                            else {
                                $dyn.telemetry.addControlActionEvent(control, null, $dyn.telemetry.ActionEvents.hotKeyUsed, eventOptions);
                            }
                        }
                        if ($dyn.ui.isInChordMode) {
                            $($dyn.shell.chordNotification).text("").hide();
                            $dyn.ui.isInChordMode = false;
                            $dyn.ui.chordKeysPressed = null;
                        }
                        var stopPropagation = $dyn.callFunction(shortcut.Handler, control, event);
                        if (stopPropagation !== false) {
                            event.preventDefault();
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("ExecuteShortcuts");
                            event.stopPropagation();
                        }
                        // break each loop
                        return false;
                    }
                }
            });
        }
        util.handleShortcuts = handleShortcuts;
        /**
         * Returns true only if two keys objects have the same value
         */
        function isChordKeyPressed(keys1, keys2) {
            if (keys1 === keys2) {
                return true;
            }
            if (keys1.shift === keys2.shift && keys1.ctrl === keys2.ctrl && keys1.alt === keys2.alt && keys1.keyCode === keys2.keyCode) {
                return true;
            }
            return false;
        }
        util.isChordKeyPressed = isChordKeyPressed;
        /**
         * Returns true only if the right combination of key code and modifier keys are pressed
         * @param event The keyboard event
         * @param keys Object describing the shortcut
         */
        function isShortcutKeyPressed(event, keys) {
            // TODO: add types for keys
            // return false if only a modifier key is pressed
            if (event.which === $dyn.ui.KeyCodes.shift || event.which === $dyn.ui.KeyCodes.ctrl || event.which === $dyn.ui.KeyCodes.alt) {
                return false;
            }
            var ctrl = keys.ctrl || false;
            var alt = keys.alt || false;
            var shift = keys.shift || false;
            var eventCtrlKey = event.ctrlKey || false;
            var eventMetaKey = event.metaKey || false;
            var eventAltKey = event.altKey || false;
            var eventShiftKey = event.shiftKey || false;
            var validShortCut = false;
            // Handle ctrl and metaKey the same way
            if (((eventCtrlKey || eventMetaKey) === ctrl || keys.isCtrlKeyAgnostic) &&
                eventAltKey === alt &&
                (eventShiftKey === shift || keys.isShiftKeyAgnostic)) {
                if (keys.keyCode instanceof Array) {
                    var idx = keys.keyCode.length - 1;
                    while (!validShortCut && idx >= 0) {
                        validShortCut = event.which === keys.keyCode[idx--];
                    }
                }
                else {
                    validShortCut = event.which === keys.keyCode;
                }
            }
            return validShortCut;
        }
        util.isShortcutKeyPressed = isShortcutKeyPressed;
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=KeyboardShortcuts.js.map
